import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import exchangeRate from '../../redux/container/ExchangeRateContainer';

const ExchangeRateModalComponent = ({ isShown, setIsShowFalse, t, ...props}) => {
  const recordedExchangeRate = props.recordedExchangeRate;
  const [exchangeRateInputVal, setExchageRateInputVal] = useState(props.curentExchangeRate)
  
  const getCurrentExchangeRate = async () => {
    try {
      await props.getCurrentExchangeRate(recordedExchangeRate.moneyType)
    } catch (error) {
      console.log("Kayıtlı exchange rate bilgisi getirilirken hata oluştu.",error)
    }
  }

  useEffect(() => {
      getCurrentExchangeRate() 
      setExchageRateInputVal(props.curentExchangeRate)
  },[props.curentExchangeRate] )

  const chageExchangeRate = (e) => {
  
    let textVal = e.target.value.match(/[a-z]/i)  || e.target.value.match(/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/)
     ? parseFloat(e.target.value) 
     : e.target.value;
    setExchageRateInputVal(textVal)
  }
  const changeRecordedExchangeRate = () => {
    const {accessToken} = props;
    if(Number(exchangeRateInputVal) !== 0 && Number(exchangeRateInputVal) !== recordedExchangeRate.exchangeRate){
      const costData = {
        exchangeRate:exchangeRateInputVal,
        costId: recordedExchangeRate.costId
      }
     props.updateRecoredExchageRate( costData, accessToken, setIsShowFalse)
    }
    else if(Number(exchangeRateInputVal) === 0 ){
      swal({
        title: "Uyarı",
        text: "Kur değeri 1 (Bir) değerinden az olamaz!",
        type: "warning",
        showConfirmButton: false
      }).catch(swal.noop);
    }

  }
  return(
    <Modal key="modal" show={isShown} >
    <Modal.Header closeButton onHide={() => {
        setIsShowFalse()
      }}>
      <Modal.Title>
        {t('changeExchangeRate')}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
    <p style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{__html: t('exchangeTCMB')}}></p>
    <div className="content table-responsive table-full-width">
    <table className="table table-hover table-bordered">
      <tbody>
        <tr>
          <td>
                        {t('note')}:
            {' '}
            {}
          </td>
          <td>
            <span style={{ fontSize: '12px' }}>
                {t('currencyNote')}   <strong>
                {`${recordedExchangeRate.exchangeRate} TL
                `
                  }
                </strong>
              </span>
          </td>
        </tr>
        <tr>
          <td>
            <span style={{ textTransform: 'uppercase' }}>
              {
                new window.Money(recordedExchangeRate.moneyType).getMoneyCode()
              }
            </span>
            {' '}
                        (
            {recordedExchangeRate.moneyType}
                        )
          </td>
          <td>
            <input
              type="text"
              style={{ width: '70%' }}
              onChange={chageExchangeRate}
              value={exchangeRateInputVal}
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
    </Modal.Body>
    <Modal.Footer>
      <button
        className="btn btn-success"
        onClick={changeRecordedExchangeRate }
      >
        {t('approve')}
      </button>
      <button
        className="btn btn-danger"
        onClick={() => setIsShowFalse()}
      >
        {t('close')}
      </button>
    </Modal.Footer>
  </Modal>
  )
}


export default connect(...exchangeRate)(ExchangeRateModalComponent);
